'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInfo = undefined;

var _UserInfo2 = require('./UserInfo');

var _UserInfo3 = _interopRequireDefault(_UserInfo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.UserInfo = _UserInfo3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserInfo/index.js
// module id = 1778
// module chunks = 0